import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../defaultState';

const userSlice = createSlice({
    name: 'User',
    initialState: initialState.user,
    reducers: {
        /** Sync Redux from localStorage after persistUser; does not write localStorage. */
        setUserState: (_state, action) => action.payload,
        /** Sync Redux during guest bootstrap and auth hydration. */
        addUser: (_state, action) => action.payload,
        deleteUser: () => {
            return initialState.user;
        },
        LogoutUser: () => {
            return initialState.user;
        },
        updateUserTvod: (state, action) => {
            if (typeof state !== 'object' || state === null) {
                return { tvodList: action.payload };
            }
            return { ...state, tvodList: [...action.payload] };
        },
    },
});

export const { setUserState, addUser, deleteUser, LogoutUser, updateUserTvod } = userSlice.actions;

export default userSlice.reducer;
